import Box from "@material-ui/core/Box";
import React, { ChangeEvent, FC } from "react";
import { WrappedComponentProps, injectIntl } from "react-intl";
import { GetListSelect } from "../../../utils/selectItems";
import CustomSelect from "../../Ui/CustomSelect";
import CustomTextField from "../../Ui/CustomTextField";
import { country } from "../../../constants/country";

interface AddressProps {
  information: any;
  disable?: boolean;
  isSubmitted?: boolean;
  isCompany?: boolean;
  isLegal?: boolean;
  handleInputChange(event: ChangeEvent<HTMLInputElement>): void;
  handleSelect(name: string, value: string): void;
}
const Address: FC<AddressProps & WrappedComponentProps> = (props) => {
  const {
    intl,
    information,
    handleInputChange,
    disable,
    isCompany,
    handleSelect,
    isLegal,
  } = props;
  const isSubmitted = props.isSubmitted ? props.isSubmitted : false;
  return (
    <Box>
      <CustomTextField
        name={isLegal ? "legalAddress" : "address"}
        label={intl.formatMessage({
          id: isCompany
            ? isLegal
              ? "Addresse de création"
              : "address.street"
            : "address.personal",
        })}
        placeholder="Addresse..."
        onChange={handleInputChange}
        value={isLegal ? information.legalAddress : information.address}
        isSubmitted={isSubmitted}
        disabled={disable}
      />
      <CustomSelect
        label={intl.formatMessage({
          id: isLegal
            ? "corporate.incorporationCountry"
            : "address.isoCountryCode",
        })}
        setValue={handleSelect}
        options={GetListSelect(country, country)}
        name={isLegal ? "legalCountryIsoCode" : "countryIsoCode"}
        value={
          (isLegal
            ? information?.legalCountryIsoCode
            : information.countryIsoCode) || "FR"
        }
        disabled={disable}
        isSubmitted={isSubmitted}
      />
      <CustomTextField
        name={isLegal ? "legalPostcode" : "postcode"}
        label={
          isLegal
            ? "Code postal de création"
            : intl.formatMessage({ id: "address.postalCode" })
        }
        placeholder="Code postale..."
        onChange={handleInputChange}
        value={isLegal ? information.legalPostcode : information.postcode}
        isSubmitted={isSubmitted}
        disabled={disable}
        type="number"
      />
      <CustomTextField
        name={isLegal ? "legalCity" : "city"}
        label={
          isLegal
            ? "Ville de création"
            : intl.formatMessage({ id: "address.city" })
        }
        placeholder="Ville..."
        onChange={handleInputChange}
        value={isLegal ? information.legalCity : information.city}
        isSubmitted={isSubmitted}
        disabled={disable}
      />
    </Box>
  );
};
export default injectIntl(Address);
